import { HABERES_VARIABLES_MODULE_ID } from './haberesVariablesModule'
import { CARGAR_NUEVO_EMPLEADO_MODULE_ID } from './cargarNuevoEmpleadoModule'
import { CONTRATOS_PROXIMOS_A_VENCER_MODULE_ID } from './contratosProximosAVencerModule'
import { VALIDADOR_LIQUIDACIONES_MODULE_ID } from './validadorLiquidacionesModule'

/**
 * Módulos de Recursos Humanos: opt-in de empresa + default staff.
 * Empresa sin hasAccess true → nadie ve el módulo.
 * Si la empresa lo tiene: ADMIN / COLABORADOR / SUPER_COLABORADOR ON;
 * USER_SMARTCFO necesita el módulo asignado en el usuario.
 */
export const RRHH_MODULE_IDS = [
  HABERES_VARIABLES_MODULE_ID,
  CARGAR_NUEVO_EMPLEADO_MODULE_ID,
  CONTRATOS_PROXIMOS_A_VENCER_MODULE_ID,
  VALIDADOR_LIQUIDACIONES_MODULE_ID,
]

export function isRrhhModule(moduleId) {
  return RRHH_MODULE_IDS.includes(moduleId)
}
